<template>
  <v-layout class="drop-footer">
    <v-flex text-center  v-show="!hideFooterBtn">
      <DrBtn
        :action="cleanSelected"
        type-btn="clearBtn-filter"
        class="text-right clearBtn-filter"
        :btnEnabled="selections.length == 0"
      >
        {{ SearchParams.Constants.ClearFilterButtonText }}
      </DrBtn>
    </v-flex>
    <v-flex class="drop-footer-btn" v-show="!hideSave" v-if="multipleChoice">
      <DrBtn
        :data-cy="`${dataCy}-btn`"
        :action="submitFilter"
        :btn-enabled="disableBtn"
        type-btn="orange_btn_search text-center"
      >
        {{ SearchParams.Constants.SaveFilterButtonText }}
      </DrBtn>
    </v-flex>
    <v-flex text-center v-else>
      <DrBtn
        :action="toggleMultiple"
        :data-cy="'cy-toggleMultiple'"
        type-btn="clearBtn-filter"
      >
        {{ SearchParams.Constants.MultipleChoiceButtonText }}
      </DrBtn>
    </v-flex>
  </v-layout>
</template>


<script>
import FilterHeaderBaseVue from './mixins/FilterHeaderBase.vue';

export default {

  mixins: [FilterHeaderBaseVue],
};
</script>
